import { File, FileGroup, TypedFiles } from '../../../../types/catalog';
import { Fragment } from 'react';

function FileCardBasic({ fileGroup }: { fileGroup: FileGroup }) {
    return (
        <>
            <div style={{ marginBottom: '4px' }}>{fileGroup.name}</div>
            <ul className="iek-prodcat-catalog-detail-docs-list">
                {(fileGroup.files as File[]).map((f, idx) => (
                    <li
                        key={idx}
                        className="iek-prodcat-catalog-detail-docs-list__item"
                        title={(f as File).name}
                    >
                        <a href={f.url} rel="noreferrer" style={{ verticalAlign: '3px' }} target="_blank">
                            <i className="glyphicon glyphicon-save-file" style={{ color: '#85858d' }} />
                            {f.name}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
}

function FileCard({ fileGroup }: { fileGroup: FileGroup }) {
    return (
        <div className="iek-prodcat-catalog-detail-docs" style={{ marginTop: '10px' }}>
            <div className="iek-prodcat-catalog-detail-docs__title">{fileGroup.name}</div>
            <div style={{ padding: '6px 6px 0 6px' }}>
                {(fileGroup.files as TypedFiles[]).map((type, idx) => {
                    return (
                        <Fragment key={idx}>
                            <div style={{ marginBottom: '4px' }}>
                                <strong>{type.type}</strong>
                            </div>
                            {type.list.map((f, idx) => (
                                <ul key={idx} className="iek-prodcat-catalog-detail-docs-list">
                                    <li className="iek-prodcat-catalog-detail-docs-list__item" title={f.name}>
                                        <a href={f.url} style={{ verticalAlign: '3px' }}>
                                            <i
                                                className="glyphicon glyphicon-save-file"
                                                style={{ color: '#85858d' }}
                                            />
                                            {f.name}
                                        </a>
                                    </li>
                                </ul>
                            ))}
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}

export { FileCard, FileCardBasic };
